import React, { useState } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, MenuItem, Typography, List, ListItem } from "@mui/material";
import { CANCEL_TYPES } from "../utils/constants";

// Shown once, at Save time, when one or more lines that have already been
// sent to the kitchen (kot_printed_qty > 0) were reduced or removed during
// this edit — not per-item as each change is made, so the waiter isn't
// interrupted mid-edit and can make all their changes first. One shared
// reason covers every affected line in this save.
export default function CancelReasonDialog({ open, items, onCancel, onConfirm }) {
  const [cancelType, setCancelType] = useState("cancel");
  const [reason, setReason] = useState("");

  const handleConfirm = () => {
    if (!reason.trim()) return;
    onConfirm({ cancelType, cancelReason: reason.trim() });
    setReason("");
    setCancelType("cancel");
  };

  return (
    <Dialog open={open} onClose={onCancel} fullWidth maxWidth="xs">
      <DialogTitle>Reason required</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" gutterBottom>
          These items have already been sent to the kitchen — a reason is required before saving:
        </Typography>
        <List dense sx={{ py: 0 }}>
          {(items || []).map((label, i) => (
            <ListItem key={i} sx={{ py: 0.25, px: 0, display: "list-item", listStyleType: "disc", ml: 2.5 }}>
              <Typography variant="body2">{label}</Typography>
            </ListItem>
          ))}
        </List>
        <TextField select label="Reason type" fullWidth size="small" value={cancelType} onChange={(e) => setCancelType(e.target.value)} sx={{ mt: 2, mb: 2 }}>
          {CANCEL_TYPES.map((c) => (
            <MenuItem key={c.value} value={c.value}>
              {c.label}
            </MenuItem>
          ))}
        </TextField>
        <TextField
          label="Reason"
          fullWidth
          size="small"
          multiline
          minRows={2}
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          autoFocus
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>Cancel</Button>
        <Button variant="contained" color="error" disabled={!reason.trim()} onClick={handleConfirm}>
          Save Changes
        </Button>
      </DialogActions>
    </Dialog>
  );
}
